module.exports = __webpack_public_path__ + "static/media/facebookShare.c709dfef.svg";